import {
  AnalysInitQuery as IData,
  AnalysInitQuery_me,
  AnalysInitQuery_me_dbsettings_values,
  AnalysInitQuery_me_dbsettings,
} from '../Queries/EkonomiskAnalysInitQuery/_QueryTypes/AnalysInitQuery';
import { IStartAnalysInfo } from '../Components/SideMenu/EkonomiskAnalysSelect/Components/FavoriteAnalysDialog/Queries/ChangeStartAnalysMutation/ChangeStartAnalysMutation';
import { AnvandarInfo } from '../Const/AnvandarInfo';
import { rutinInfos } from '../../../../_Common/Const/RutinInfo';
import Logger from '../../../../../../Utils/Logger';
import { isAnalysFavoriteSortMode } from '../Components/SideMenu/EkonomiskAnalysSelect/Components/FavoriteAnalysDialog/EkonomiskAnalysFavoriteAnalysDialog';
import { IRecentAnalysInfo } from '../Components/SideMenu/EkonomiskAnalysSelect/AddToRecentAnalyserMutation/AddToRecentAnalyserMutation';
import { isSameAnalys } from '../Components/SideMenu/EkonomiskAnalysSelect/Components/FavoriteAnalysDialog/Utils/EkonomiskAnalysFavoriteAnalysDialogUtils';
import { ISelection } from '../Queries/EkonomiskAnalysInitQuery/EkonomiskAnalysInitQuery';
import { IActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
export interface IAnalysGroupingModeUserInfo {
  value: string;
  id: string;
}

export interface IAnalysBudgetModeUserInfo {
  value: string;
  id: string;
}

export interface IUserInfo {
  startAnalys?: IStartAnalysInfo;
  analysGroupingMode?: IAnalysGroupingModeUserInfo;
  recentAnalyser?: IRecentAnalysInfo[];
  useCurrentDateAsStartDate: boolean;
  detailTableRowsPerPage?: number | null;
  utanSummeringRowsPerPage?: number | null;
  lastReportedPeriod?: {
    year: number;
    month: number;
  };
  delsystemAnsvarigEkonomi: boolean;
  updateStartanalysAtLogin: boolean;
  isUtdelningBehorig: boolean;
  analysBudgetMode?: IAnalysBudgetModeUserInfo;
  preferHelarsjamforelse?: boolean;
  useZeroSums?: boolean;
  isSideMenuPinned?: boolean;
  canHandleBfo?: IBooleanMessage;
}
export interface IBooleanMessage {
  result: boolean;
  message: string | null;
}

export const getValue = (
  values: AnalysInitQuery_me_dbsettings_values[],
  valueName: string
) => {
  return values.find(x => x.name === valueName);
};

export const getStartAnalys = (
  startAnalys: string
): IStartAnalysInfo | undefined => {
  return startAnalys !== '' ? JSON.parse(startAnalys) : undefined;
};

export const getRecentAnalyser = (
  recentAnalyser: string | null,
  availableReports: ISelection[]
): IRecentAnalysInfo[] => {
  if (recentAnalyser) {
    // Filtrera bort analyser som vi inte har på favoritmenyn längre
    const analysResult: IRecentAnalysInfo[] = JSON.parse(recentAnalyser);
    const filteredAnalysResult = analysResult.filter(analys =>
      availableReports.some(
        availableKodbeh =>
          availableKodbeh.id === analys.kodbehId &&
          availableKodbeh.analysList.some(
            availableAnalys =>
              isSameAnalys(
                {
                  rapportId: availableAnalys.id,
                  utdelningLopnr: availableAnalys.utdelatLopnr,
                  idKod: undefined,
                  kodbehorighet: availableKodbeh.id,
                },
                {
                  rapportId: analys.analysId,
                  utdelningLopnr: analys.utdelningLopnr,
                  idKod: undefined,
                  kodbehorighet: analys.kodbehId,
                }
              ) &&
              availableAnalys.favoritLopnr !== null &&
              availableAnalys.baseSelection.id === analys.baseSelectionId
          )
      )
    );

    //Lägg till idkod på varje analys
    const updatedAnalysResult = filteredAnalysResult.reduce((prev, curr) => {
      const report = availableReports.find(
        kodbeh => kodbeh.id === curr.kodbehId
      );
      if (report) {
        const analys = report.analysList.find(
          analysItem => analysItem.id === curr.analysId
        );
        if (analys) {
          return [...prev, { ...curr, analysIdKod: analys.idkod }];
        } else {
          return prev;
        }
      } else {
        return prev;
      }
    }, [] as IRecentAnalysInfo[]);

    return updatedAnalysResult;
  }

  return [];
};

export const getAnalysGroupBy = (
  section: AnalysInitQuery_me_dbsettings | null
): IAnalysGroupingModeUserInfo | undefined => {
  if (section && section.values) {
    const analysGroupByNameValuePair = getValue(
      section.values,
      AnvandarInfo.analysGroupingMode.name
    );

    if (
      analysGroupByNameValuePair &&
      analysGroupByNameValuePair.value &&
      analysGroupByNameValuePair.value.__typename === 'TEDMixedString'
    ) {
      const analysGroupBy = analysGroupByNameValuePair.value.asString;

      if (analysGroupBy) {
        if (isAnalysFavoriteSortMode(analysGroupBy)) {
          return {
            id: analysGroupByNameValuePair.id,
            value: analysGroupBy,
          };
        } else {
          Logger.error(
            `Unknown setting value: ${analysGroupBy} found at setting ${AnvandarInfo.analysGroupingMode.name}`
          );
        }
      }
    }
  }

  return undefined;
};

export const getPreferHelarsjamforelse = (
  section: AnalysInitQuery_me_dbsettings | null
): boolean | undefined => {
  if (section && section.values) {
    const analysBudgetNameValuePair = getValue(
      section.values,
      AnvandarInfo.ekonomiskAnalysPreferHelarsJamforelse.name
    );

    if (
      analysBudgetNameValuePair &&
      analysBudgetNameValuePair.value &&
      analysBudgetNameValuePair.value.__typename === 'TEDMixedString'
    ) {
      return analysBudgetNameValuePair.value.asString === 'Y';
    }
    return undefined;
  }
  return undefined;
};

export const getUseCurrentDateAsStartDate = (
  section: AnalysInitQuery_me_dbsettings | null
): boolean => {
  if (section && section.values) {
    const useCurrentDateAsStartDate = getValue(
      section.values,
      AnvandarInfo.useCurrentDateAsStartDate.name
    );

    if (
      useCurrentDateAsStartDate &&
      useCurrentDateAsStartDate.value &&
      useCurrentDateAsStartDate.value.__typename === 'TEDMixedString'
    ) {
      return useCurrentDateAsStartDate.value.asString === 'Y';
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const getZeroSums = (
  section: AnalysInitQuery_me_dbsettings | null
): boolean => {
  if (section && section.values) {
    const useZeroSums = getValue(
      section.values,
      AnvandarInfo.ekonomiskAnalysUseZeroSums.name
    );

    if (
      useZeroSums &&
      useZeroSums.value &&
      useZeroSums.value.__typename === 'TEDMixedString'
    ) {
      return useZeroSums.value.asString !== 'N';
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const getDBSectionNumberValue = (
  section: AnalysInitQuery_me_dbsettings | null,
  name: string
): number | null => {
  if (section && section.values) {
    const value = getValue(section.values, name);

    if (value && value.value && value.value.__typename === 'TEDMixedString') {
      const res = parseInt(value.value.asString ?? '', 10);

      return isNaN(res) ? null : res;
    }
  }
  return null;
};

export const getDBSectionBooleanValue = (
  section: AnalysInitQuery_me_dbsettings | null,
  name: string,
  defaultValue: boolean
): boolean => {
  if (section && section.values) {
    const value = getValue(section.values, name);

    if (value && value.value && value.value.__typename === 'TEDMixedString') {
      return value.value.asString === 'Y';
    }
  }
  return defaultValue;
};

export const getUserInfo = (
  data: IData,
  me: AnalysInitQuery_me[],
  rutinAvailabilityInfo: IActiveDatabaseContext,
  availableReports: ISelection[]
): IUserInfo => {
  let info: IUserInfo = {
    canHandleBfo: me[0]?.farHanteraBokforder,
    useCurrentDateAsStartDate: false,
    delsystemAnsvarigEkonomi: false,
    updateStartanalysAtLogin: true,
    isUtdelningBehorig: false,
    useZeroSums: true,
  };

  const startAnalysSection = data.ek_ekanalys_startanalys?.value ?? null;
  const recentAnalyserSection = data.ek_ekanalys_recentanalyser?.value ?? null;
  const dbSection = me[0]?.dbsettings?.[0] ?? null;

  info.startAnalys = getStartAnalys(startAnalysSection ?? '');
  info.analysGroupingMode = getAnalysGroupBy(dbSection);
  info.preferHelarsjamforelse = getPreferHelarsjamforelse(dbSection) ?? true;
  info.recentAnalyser = getRecentAnalyser(
    recentAnalyserSection,
    availableReports
  );
  info.useCurrentDateAsStartDate = getUseCurrentDateAsStartDate(dbSection);
  info.detailTableRowsPerPage = getDBSectionNumberValue(
    dbSection,
    AnvandarInfo.ekonomiskAnalysDetailTableRowsPerPage.name
  );
  info.utanSummeringRowsPerPage = getDBSectionNumberValue(
    dbSection,
    AnvandarInfo.ekonomiskAnalysUtanSummeringRowsPerPage.name
  );
  info.delsystemAnsvarigEkonomi = me[0]?.delsystemAnsvarig.value ?? false;
  info.isUtdelningBehorig =
    rutinAvailabilityInfo.availableRoutines?.[
      rutinInfos.rtnAnalysutdelning.rutinID
    ] != null &&
    !rutinAvailabilityInfo.availableRoutines[
      rutinInfos.rtnAnalysutdelning.rutinID
    ]?.readonly;
  info.updateStartanalysAtLogin = getDBSectionBooleanValue(
    dbSection,
    AnvandarInfo.ekonomiskAnalysUpdateStartanalysAtLogin.name,
    true
  );
  info.useZeroSums = getDBSectionBooleanValue(
    dbSection,
    AnvandarInfo.ekonomiskAnalysUseZeroSums.name,
    true
  );
  info.isSideMenuPinned = getDBSectionBooleanValue(
    dbSection,
    AnvandarInfo.ekonomiskAnalysIsSideMenuPinned.name,
    true
  );

  return info;
};
